import { render, staticRenderFns } from "./InterviewSettings.vue?vue&type=template&id=754f4a3d"
import script from "./InterviewSettings.vue?vue&type=script&lang=js"
export * from "./InterviewSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports